import { useState } from "react";

interface HeroProps {
  onSearch: (keyword: string) => void;
}

const quickTags = ["萌系漫画", "少女漫画", "甜宠漫画", "治愈漫画", "校园恋爱"];

const stats = [
  { value: "3200+", label: "收录作品" },
  { value: "120+", label: "每日更新" },
  { value: "680万+", label: "读者追更" },
];

export default function Hero({ onSearch }: HeroProps) {
  const [keyword, setKeyword] = useState("");

  const submit = (value: string) => {
    onSearch(value);
    document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative flex min-h-[88vh] items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=dreamy%20soft%20anime%20illustration%20of%20a%20cute%20white%20cat%20and%20falling%20cherry%20blossoms%20with%20sparkling%20pastel%20stars%20on%20a%20gentle%20cream%20to%20soft%20pink%20gradient%20background%2C%20moe%20kawaii%20manga%20art%20style%2C%20warm%20and%20cozy%2C%20high%20detail%2C%20artistic%20and%20dreamy&width=1600&height=900&seq=keke-hero-01&orientation=landscape"
        alt="软萌可爱的漫画少女与樱花背景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40" aria-hidden="true"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center text-background-50 md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/15 px-4 py-1.5 text-sm font-medium backdrop-blur-sm">
          <i className="ri-heart-pulse-line" aria-hidden="true"></i>
          软萌角色 · 高甜不虐 · 每日追更
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight md:text-6xl">
          可可漫画网
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          聚合萌系漫画、少女漫画与甜宠漫画的轻量追更门户。软萌角色搭配可爱画风，
          恋爱剧情高甜不虐，点开即可按题材找漫，追更、收藏、更新提醒一步到位。
        </p>

        <form
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row"
          onSubmit={(e) => {
            e.preventDefault();
            submit(keyword);
          }}
          role="search"
        >
          <label className="sr-only" htmlFor="hero-search">搜索漫画</label>
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-5 py-3 text-foreground-800">
            <i className="ri-search-line text-lg text-foreground-500" aria-hidden="true"></i>
            <input
              id="hero-search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜一搜你喜欢的萌系 / 甜宠漫画…"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始找漫
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {quickTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => submit(tag)}
              className="whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm transition-colors hover:bg-primary-500/80"
            >
              {tag}
            </button>
          ))}
        </div>

        <dl className="mx-auto mt-12 grid max-w-lg grid-cols-3 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50/15 px-2 py-3 backdrop-blur-sm">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-xl md:text-2xl">{s.value}</dd>
              <dd className="mt-1 text-xs text-background-200">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}